import { render, staticRenderFns } from "./BusGisWechatDeveloperMsgTempModal__Style#Drawer.vue?vue&type=template&id=bf22f996&scoped=true&"
import script from "./BusGisWechatDeveloperMsgTempModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./BusGisWechatDeveloperMsgTempModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./BusGisWechatDeveloperMsgTempModal__Style#Drawer.vue?vue&type=style&index=0&id=bf22f996&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf22f996",
  null
  
)

export default component.exports